<template>
  <div>
    <dd-dialog-modal
        :visible="popoverVisible"
        title="Wil je de campagne eenmalig of automatisch draaien?"
        @cancel="hide"
    >
      <template #content>
        <div class="flex-col">
          <dd-radio-group
              class="mb-md"
              v-model="run_interval"
              group-name="run-interval"
              rules="required"
          >
            <dd-radio value="daily">Dagelijks</dd-radio>
            <dd-radio value="weekly">Wekelijks</dd-radio>
            <dd-radio value="monthly">Maandelijks</dd-radio>
          </dd-radio-group>
        </div>
      </template>
      <template #buttons>
        <dd-button @click="popoverVisible = false" :outline="true" type="primary">Annuleren</dd-button>
        <dd-button @click="confirm" type="primary">Bevestigen</dd-button>
      </template>
    </dd-dialog-modal>
    <div @click="onActivated(isActive)">
        <slot name="button" :is-active="isActive"></slot>
    </div>
  </div>
</template>

<script>
import {AutomationableTypeEnum} from "../enums";
import globalAutomationConfigurationApi from "~/api/global_automation_configuration";
import automationApi from "~/api/automation";

export default {
  name: "AutomationExecutionSwitch",
  props: {
    automation: {
      type: Object,
      required: true
    },
  },
  computed: {
    isActive() {
      return this.automation.active;
    },
    isGlobal() {
      return !!this.automation.global_automation_id;
    },
  },
  data() {
    return {
      popoverVisible: false,
      run_interval: this.automation.run_interval,
    };
  },
  methods: {
     confirm() {
      if (this.isGlobal) {
        globalAutomationConfigurationApi.activate(this.automation.id, this.run_interval)
            .then(() => {
              this.$emit('saved', { id: this.automation.global_automation_id, type:AutomationableTypeEnum.GLOBAL_AUTOMATION });
              this.popoverVisible = false;
            });
      } else {
        automationApi.activate(this.automation.id, this.run_interval)
            .then(() => {
              this.$emit('saved', {id: this.automation.id});
              this.popoverVisible = false;
            });
      }
     },
     cancel() {
       this.$emit('input', false);
     },
    onActivated(isActive) {
       if (isActive === true) {
         if (this.isGlobal) {
           globalAutomationConfigurationApi.deactivate(this.automation.id)
               .then(() => {
                 this.$emit('saved', { id: this.automation.global_automation_id, type:AutomationableTypeEnum.GLOBAL_AUTOMATION });
                 this.popoverVisible = false;
               });
         } else {
           automationApi.deactivate(this.automation.id)
               .then(() => {
                  this.$emit('saved', {id: this.automation.id});
                 this.popoverVisible = false;
               })
         }
       } else {
         this.popoverVisible = true;
       }
    },
    hide() {
       // Do api call to activate automation
       // Reload the page, because order of automations might have changed
      // close the popover
      this.popoverVisible = false;
    },
  },
};
</script>

<style lang="scss" >
@import "~@/_default.scss";
.automation-execution-switch {
  // a-switch
  .ant-switch-checked {
    background-color: $brand-primary !important;
  }
}
</style>
